import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { RouterModule } from '@angular/router';
import { PacksSearchComponent } from './packs-search/packs-search.component';
import { PackComponent } from './packs-management/pack.component';
import { PackTabComponent } from './packs-management/pack-tab/pack-tab.component';
import { ReferencesModule } from '@administration/references/references.module';
import { PackTargetDomainsComponent } from './packs-management/pack-tab/pack-target-domains/pack-target-domains.component';
import { PackRecipeTabComponent } from './packs-management/pack-recipe-tab/pack-recipe-tab.component';
import { PackArchivesListComponent } from './packs-management/pack-recipe-tab/archive-management/archive-list/pack-archives-list.component';
// eslint-disable-next-line max-len
import { PackGenerateArchiveFormComponent } from './packs-management/pack-recipe-tab/archive-management/pack-generate-archive-form/pack-generate-archive-form.component';
import { PackBinariesListComponent } from './packs-management/pack-recipe-tab/binaries-management/pack-binaries-list/pack-binaries-list.component';
// eslint-disable-next-line max-len
import { PackGenerateBinaryFormComponent } from './packs-management/pack-recipe-tab/binaries-management/pack-generate-binary-form/pack-generate-binary-form.component';
import { SharedLibsModule } from '@shared/shared-libs.module';
import { EditPackNamePopinComponent } from './packs-management/pack-tab/pack-edit-name-popin/edit-pack-name-popin.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DataTableManagerComponent } from '@shared/components/data-table-manager/data-table-manager.component';
import { FilterDomainMarketLangComponent } from '@shared/components/filter-domain-market-lang/filter-domain-market-lang.component';
import { isLoginInGuard } from '@guards/isLogin.guard';

@NgModule({
  declarations: [
    PacksSearchComponent,
    PackComponent,
    PackTabComponent,
    PackTargetDomainsComponent,
    PackRecipeTabComponent,
    PackArchivesListComponent,
    PackGenerateArchiveFormComponent,
    PackBinariesListComponent,
    PackGenerateBinaryFormComponent,
    EditPackNamePopinComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedLibsModule,
    MatDialogModule,
    RouterModule.forChild([
      {
        path: 'new',
        component: PackComponent,
      },
      {
        path: 'search',
        component: PacksSearchComponent,
        canActivate: [isLoginInGuard],
      },
      {
        path: 'edit/:packId',
        component: PackComponent,
      },
    ]),
    ReferencesModule,
    DataTableManagerComponent,
    FilterDomainMarketLangComponent,
  ],
})
export class PacksModule {}
